export const projectMutationKeys = {
  all: ["PROJECT_DETAIL"],
  mutateProjectComments: (options?: string[]) => [
    ...projectMutationKeys.all,
    "COMMENTS",
    ...(options || []),
  ],
  mutateCommentReplies: (options?: string[]) => [
    ...projectMutationKeys.all,
    "COMMENTS_REPLIES",
    ...(options || []),
  ],
};
